export interface InterfaceMonitoringSearchCriteria {
    messageType?: string | null,
    from?: string | null,
    to?: string | null,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    status?: string | null,
    interfaceMonitorHdrId?: number | null,
    type: string,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA: InterfaceMonitoringSearchCriteria = {
    messageType: '',
    from: '',
    to: '',
    dateFrom: null,
    dateTo: null,
    status: '',
    interfaceMonitorHdrId: 0,
    type: '',
}